import { Container } from './Container';
import { Button } from './Button';

const buildSteps = [
  {
    label: 'Step 1',
    title: 'Choose a game',
    copy: 'Start from a ready-made arcade or quiz format that already works on mobile.',
  },
  {
    label: 'Step 2',
    title: 'Brand the game',
    copy: 'Change the visible campaign elements yourself, without waiting on a designer.',
  },
  {
    label: 'Step 3',
    title: 'Publish once',
    copy: 'Use the same playable campaign anywhere you can share a link or QR code.',
  },
];

export function BuildSimple() {
  return (
    <section className="sf-section sf-section-build py-10 sm:py-16" aria-labelledby="build-simple-heading">
      <Container>
        <div className="mx-auto max-w-5xl">
          <div className="mx-auto max-w-3xl text-center">
            <h2 id="build-simple-heading" className="font-arcade text-2xl tracking-tight text-gch-accent sm:text-3xl">
              Build it yourself in minutes
            </h2>
            <p className="mt-3 text-base leading-7 text-gch-text-secondary">
              Pick from the game library, change the brand pieces, then publish a link or QR code without waiting on a design team.
            </p>
          </div>

          <div className="sf-build-flow mt-8">
            {buildSteps.map((step) => (
              <article className="sf-build-step" key={step.label}>
                <p className="sf-build-kicker">{step.label}</p>
                <h3>{step.title}</h3>
                <p>{step.copy}</p>
              </article>
            ))}
          </div>

          <div className="mt-8 text-center">
            <Button href="/studio/register">Build a game free</Button>
          </div>
        </div>
      </Container>
    </section>
  );
}
